import { mdiCalendarClock } from "@mdi/js"
import {
  buildViewNavigation,
  type PageTabWithId,
  type ViewPageSnippets,
  type ViewPageSpec,
} from "@kontextwerk/web-sdk/core/navigation/viewNavigation"
import type { PermissionState } from "@kontextwerk/control-web-frame/logic/permissions/model"

type WorkOrdersViewFrameContext = {
  permissions: PermissionState
  currentUserId: string | null
  workOrderArchived: boolean
}

export type WorkOrderDetailViewPaths = {
  details: string
  letter: string
  contactPlanning: string
}

export type WorkOrderDetailNavigationCapabilities = {
  contactFlowsLocked: boolean
}

export const buildWorkOrderDetailViewPaths = (basePath: string): WorkOrderDetailViewPaths =>
  basePath
    ? {
        details: `${basePath}/details`,
        letter: `${basePath}/letter`,
        contactPlanning: `${basePath}/communications`,
      }
    : {
        details: "",
        letter: "",
        contactPlanning: "",
      }

const getSchedulePlanningTabs = (ctx: WorkOrdersViewFrameContext): PageTabWithId[] => {
  const canViewScheduling =
    ctx.permissions.allows("termin.scheduling", "view") ||
    ctx.permissions.allows("termin.scheduling", "manage")

  if (!canViewScheduling) return []

  return ctx.workOrderArchived
    ? [{ id: "details", title: "Auftrag" }]
    : [
        { id: "details", title: "Auftrag" },
        { id: "planning", title: "Termine" },
      ]
}

const PAGE_SPECS: Array<
  ViewPageSpec<
    WorkOrdersViewFrameContext,
    WorkOrderDetailViewPaths,
    WorkOrderDetailNavigationCapabilities
  >
> = [
  {
    id: "schedulePlanning",
    title: "Auftrag",
    icon: mdiCalendarClock,
    resolvePath: (paths) => paths.contactPlanning,
    getTabs: getSchedulePlanningTabs,
  },
]

export const buildWorkOrderDetailViewNavigation = ({
  context,
  paths,
  capabilities,
  snippets,
}: {
  context: WorkOrdersViewFrameContext
  paths: WorkOrderDetailViewPaths
  capabilities: WorkOrderDetailNavigationCapabilities
  snippets: ViewPageSnippets
}) =>
  buildViewNavigation({
    specs: PAGE_SPECS,
    context,
    paths,
    capabilities,
    snippets,
  })
